import React, {useEffect} from 'react';
import PropTypes from "prop-types";

import {PreFetchDataContext} from "@/contexts/PreFetchDataContext.jsx";
import {useFetchData} from "@/hooks/useFetchData.jsx";

export const PreFetchDataProvider = ({endpoint, children}) => {
    const {
        data: preFetchedData,
        isLoading,
        fetchData,
    } = useFetchData({endpoint});

    useEffect(() => {
        if (endpoint) {
            fetchData();
        }
    }, [endpoint]);

    const reFetchPreData = () => {
        fetchData();
    }

    return (
        <PreFetchDataContext.Provider
            value={{preFetchedData, reFetchPreData}}>
            {children}
        </PreFetchDataContext.Provider>
    );
};

PreFetchDataProvider.propTypes = {
    children: PropTypes.any,
};
